





































































import Vue from "vue";
import MaskedLoading from "@/components/atoms/MaskedLoading.vue";
import { showNotifyDialog } from "@/lib/dialog";
import ContestCard from "@/components/molecules/ContestCard.vue";
import SelectBox from "@/components/molecules/SelectBox.vue";
import MenuIcon from "icons/Menu.vue";
import { genre as genreList, category as categoryList } from "@/lib/novelSettings";
import { NovelSetting } from "@/lib/models";
import { format } from "date-fns";
import compareAsc from "date-fns/compare_asc";
import compareDesc from "date-fns/compare_desc";
import axiosBase from "axios";
const axios = axiosBase.create({
  baseURL: process.env.VUE_APP_MICROCMS_API_ENDPOINT,
  headers: { "X-API-KEY": process.env.VUE_APP_MICROCMS_API_KEY },
});

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ContestCard,
    SelectBox,
    MaskedLoading,
    MenuIcon,
  },
  async created() {
    const contestRequest = await axios.get(`/contest`);
    if (contestRequest.status !== 200) {
      await showNotifyDialog({
        title: "エラー",
        content: "コンテスト情報の取得に失敗しました。",
      });
    }
    this.contests = contestRequest.data.contents;
    this.isLoading = false;
  },
  data() {
    return {
      isLoading: true,
      contests: [],
      selectedGenre: "all",
      selectedCategory: null,
      genreList,
      categoryList,
    };
  },
  computed: {
    latestContests() {
      const { availableContests } = this;
      return availableContests.slice(0, 3);
    },
    filterdContests() {
      const { availableContests, selectedGenre, selectedCategory, genreName } = this;

      let filterdContests = availableContests;

      if (selectedGenre !== "all") {
        filterdContests = filterdContests.filter((contest) => contest.genre.includes(genreName(selectedGenre)));
      }

      if (selectedCategory) {
        filterdContests = filterdContests.filter((contest) => contest.category.includes(selectedCategory.name));
      }

      return filterdContests.sort((a, b) => {
        const aDeadline = format(a.deadline, "YYYY-MM-DD");
        const bDeadline = format(b.deadline, "YYYY-MM-DD");

        return compareDesc(aDeadline, bDeadline);
      });
    },
    genreName() {
      return (genreId) => {
        const targetGenre = genreList.find((genre) => genre.id === genreId);
        return targetGenre ? targetGenre.name : "";
      };
    },
    availableContests() {
      const { contests } = this;
      const currentDate = format(new Date(), "YYYY-MM-DD");
      return contests.filter((contest) => {
        const contestDeadline = format(contest.deadline, "YYYY-MM-DD");
        return compareAsc(currentDate, contestDeadline) !== 1;
      });
    },
    closedContests() {
      const { contests } = this;
      const currentDate = format(new Date(), "YYYY-MM-DD");
      const closedContests = contests.filter((contest) => {
        const contestDeadline = format(contest.deadline, "YYYY-MM-DD");
        return compareAsc(currentDate, contestDeadline) === 1;
      });

      return closedContests.sort((a, b) => {
        const aDeadline = format(a.deadline, "YYYY-MM-DD");
        const bDeadline = format(b.deadline, "YYYY-MM-DD");

        return compareDesc(aDeadline, bDeadline);
      });
    },
  },
  methods: {
    onClickBack() {
      const { $router } = this;
      $router.push({ name: "home" });
    },
    onClickGenre(genreId) {
      this.selectedGenre = genreId;
    },
    selectCategory(item) {
      this.selectedCategory = item;
    },
    unselectCategory() {
      this.selectedCategory = null;
    },
  },
});

interface Props {}

interface Data {
  isLoading: boolean;
  contests: Contest[];
  selectedGenre: string;
  selectedCategory: NovelSetting | null;
  genreList: NovelSetting[];
  categoryList: NovelSetting[];
}

interface Computed {
  latestContests: Contest[];
  filterdContests: Contest[];
  genreName(genreId: string): string;
  availableContests: Contest[];
  closedContests: Contest[];
}

interface Methods {
  onClickBack(): void;
  onClickGenre(genreId: string): void;
  selectCategory(item: NovelSetting): void;
  unselectCategory(): void;
}

type Contest = {
  [key: string]: any;
};
